var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEhr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 21 17",
    width: 19,
    height: 15,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1, 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-preferred-contact",
    transform: "translate(-341.000000, -584.000000)",
    fill: "#585D63",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-ehr",
    transform: "translate(341.000000, 583.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.8875,7.65 L8.55,7.65 L8.55,9.3125 C8.55,9.44366763 8.65633237,9.55 8.7875,9.55 L10.2125,9.55 C10.3436676,9.55 10.45,9.44366763 10.45,9.3125 L10.45,7.65 L12.1125,7.65 C12.2436676,7.65 12.35,7.54366763 12.35,7.4125 L12.35,5.9875 C12.35,5.85633237 12.2436676,5.75 12.1125,5.75 L10.45,5.75 L10.45,4.0875 C10.45,3.95633237 10.3436676,3.85 10.2125,3.85 L8.7875,3.85 C8.65633237,3.85 8.55,3.95633237 8.55,4.0875 L8.55,5.75 L6.8875,5.75 C6.75633237,5.75 6.65,5.85633237 6.65,5.9875 L6.65,7.4125 C6.65,7.54366763 6.75633237,7.65 6.8875,7.65 Z M17.1,2.425 C17.0977173,1.6389417 16.4610583,1.0022827 15.675,1 L3.325,1 C2.5389417,1.0022827 1.9022827,1.6389417 1.9,2.425 L1.9,12.4 L17.1,12.4 L17.1,2.425 Z M15.2,10.5 L3.8,10.5 L3.8,2.9 L15.2,2.9 L15.2,10.5 Z M18.525,13.35 L11.3269687,13.35 C11.305,13.9381094 10.8902656,14.3 10.355,14.3 L8.55,14.3 C7.99514062,14.3 7.5703125,13.7813594 7.57714062,13.35 L0.475,13.35 C0.212664744,13.35 0,13.5626647 0,13.825 L0,14.3 C0.00309764023,15.3480553 0.851944741,16.1969024 1.9,16.2 L17.1,16.2 C18.1480553,16.1969024 18.9969024,15.3480553 19,14.3 L19,13.825 C19,13.5626647 18.7873353,13.35 18.525,13.35 L18.525,13.35 Z",
    id: "Shape",
    vectorEffect: "non-scaling-stroke"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEhr);
export default __webpack_public_path__ + "static/media/EHR.0de41b762a2891b1f223dc29f4f9f7f7.svg";
export { ForwardRef as ReactComponent };